
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/editor-console/content/shared/image-link-input/image-link-input",
      function () {
        return require("private-next-pages/admin/editor-console/content/shared/image-link-input/image-link-input.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/editor-console/content/shared/image-link-input/image-link-input"])
      });
    }
  